diy.angular.registerFactory('diyfmsourcepatterns', ['$q', '$injector', '$http', 'diyl10n', 'diyfmsectionmodel', 'diyfmsubsectionmodel', 'diyfmconstpattern', 'diyfmconfig',
function($q, $injector, $http, diyl10n, diyfmsectionmodel, diyfmsubsectionmodel, diyfmconstpattern, diyfmconfig) {
    var
        source = {},
        itemsProvider = {}
    ;

    var getName = function() {
        return 'patterns';
    };

    var backgroundColor = diyfmconfig.getSourceSetting(getName(), 'backgroundColor');

    var getBackgroundColor = function() {
        return backgroundColor;
    };

    var setBackgroundColor = function(color) {
        backgroundColor = color;
    };

    var setBackgroundColorToData = function(data) {
        data.forEach(function(item) {
            item.id.backgroundColor = backgroundColor;
        });
    };

    var getSectionModel = function() {
        return $injector.get('diyfmsectioncompany');
    };

    var patternsDataCache;

    itemsProvider.queryRange = function(params, offset, limit) {
        var defer = $q.defer(), items;

        if (patternsDataCache) {
            // we need a deep copy in case background color will be changed
            items = angular.copy(patternsDataCache);
            setBackgroundColorToData(items);
            defer.resolve({
                items: items,
                totalCount: patternsDataCache.length
            });
        } else {

            var url = '/app/module/emotionheader/patterns?';

            var
                thumbSize = diyfmconfig.getThumbSize(),
                previewSize = diyfmconfig.getPreviewSize()
            ;

            url += '&thumbWidth=' + thumbSize.width;
            url += '&thumbHeight=' + thumbSize.height;
            url += '&previewWidth=' + previewSize.width;
            url += '&previewHeight=' + previewSize.height;

            $http.get(url)
                .success(function(data, status, headers, config) {
                    if (data && data.data) {
                        // because patterns are invariable, let's cache them to save
                        // roundtrips to the server
                        patternsDataCache = data.data;
                        // HACK: We need to make patterns unique when bg color changes
                        // so we force another refresh from the server, but we inject
                        // a different color variant in the id, so we'll have different
                        // objects
                        setBackgroundColorToData(patternsDataCache);
                        defer.resolve({items: patternsDataCache, totalCount: patternsDataCache.length});
                    } else {
                        diyfmmessages.handleGenericError();
                    }
                }).error(function(data, status, headers, config) {
                    diyfmmessages.handleGenericError();
                    defer.reject();
                });
        }
        return defer.promise;
    };

    var getItemsProvider = function() {
        return itemsProvider;
    };

    var getThumbStyle = function(item) {
        return {
            backgroundColor: '#' + item.getId().backgroundColor
        };
    };

    var getPreviewStyle = function(item) {
        return {
            backgroundColor: '#' + item.getId().backgroundColor
        };
    };

    var getInsertThumbStyle = function(item) {
        return 'background-color: #' + item.getId().backgroundColor;
    };

    angular.module(diyfmconfig.getAppName()).compileProvider.directive('diyfmpatternscolorpicker', [
        'diyl10n',
        'diyfmsectionsdata',
        'diyfmselectiondata',
        function(
            diyl10n,
            diyfmsectionsdata,
            diyfmselectiondata
        ){
        return {
            template: '<div class="fm-toolbar-pattern-color"\
                <label for="eh-color-picker-wrapper">' + diyl10n('emotionheader.background.patternColorLabel') + '</label>\
                <div class="pattern-color-picker"></div>\
            </div>',
            restrict: 'A',
            scope: true,
            link: function(scope, elem, attr) {
                var $patternColorPickerContainer = jQuery('.pattern-color-picker', elem);

                var subsection = diyfmsectionsdata.getCurrentSubsection();

                var bgColor = subsection.getSource().getBackgroundColor();

                $patternColorPickerContainer.colorPicker({
                    mode: 'button',
                    layerAlign: 'right',
                    color: '#' + bgColor,
                    showButtons: true,
                    onColorAccept: function (color) {
                        scope.$apply(function() {
                            subsection.getSource().setBackgroundColor(color);
                            subsection.clearItemsCache();
                            diyfmselectiondata.removeAllItems(['select']);
                        });
                    }
                });

                elem.bind('$destroy', function(){
                    if ($patternColorPickerContainer) {
                        $patternColorPickerContainer.data('colorpicker').abortColor();
                        $patternColorPickerContainer = null;
                    }
                });
            }
        }
    }]);

    var toolbarItems = [];

    if (diyfmconfig.getSourceSetting(getName(), 'enableBgColorPicker')) {
        toolbarItems = [
            ' ', // spacer
            function() {
                return '<div diyfmpatternscolorpicker></div>';
            }
        ];
    }

    var getToolbarItems = function(subsection) {
        return toolbarItems;
    };

    return angular.extend(source, {
        getName: getName,
        getSectionModel: getSectionModel,
        getItemsProvider: getItemsProvider,
        getBackgroundColor: getBackgroundColor,
        setBackgroundColor: setBackgroundColor,
        getThumbStyle: getThumbStyle,
        getPreviewStyle: getPreviewStyle,
        getInsertThumbStyle: getInsertThumbStyle,
        getToolbarItems: getToolbarItems
    });
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/sources/diyfmsourcepatterns.js
 ** module id = 948
 ** module chunks = 0
 **/